import React from 'react'

import FieldsCollection from "../../../../../fields3/collection/base/fields-collection"
import InfoPanelRow from "../../../../../gd-ui/ip-section-row/info-panel-row"
import FieldInlineEditable from "../../../../../fields3/render/inline-editable"
import ProjectUserFull from "../../../../../model2/project-user/project-user-full"
import ProjectUser_initProjectTeamFields from "./functions/init-project-team-fields"
import ProjectUser_initWorkspaceTeamFields from "./functions/init-workspace-team-fields"

type Props = {
    projectUser     : ProjectUserFull
    projectUsers    : ProjectUserFull[]

    actions         : any
}

export default class ModalTeamDefault extends React.Component<Props> {

    private fields: FieldsCollection

    constructor(props: Props) {
        super(props)

        const isWorkspace = gd.session.projects.get(props.projectUser.projectId)?.isWorkspace

        if (isWorkspace) {
            this.fields = ProjectUser_initWorkspaceTeamFields(props.projectUser.projectId)
        } else {
            this.fields = ProjectUser_initProjectTeamFields(props.projectUser.projectId)
        }
    }

    render() {
        const team = gd.session.teams.get(this.props.projectUser.teamId)!

        return (
            <>
                <div className="iv-header header-left header-small-no-separator">
                    <div className="title-line">
                        <div className="view-name">
                            <div className="view-name ui5-title-app-name">{team.name}</div>
                        </div>
                    </div>
                </div>

                <div className="iv-content with-left-panel">
                    <div className="ui5-info-panel big-panel m-l-10 m-r-10">

                        <div className="ip-section">
                            <InfoPanelRow label="Access">
                                <FieldInlineEditable field={this.fields.get('access')}
                                                     model={{
                                                         access         : this.props.projectUser.access,
                                                         projectUser    : this.props.projectUser,
                                                         projectUsers   : this.props.projectUsers
                                                     }} onChange={this.props.actions.onAccessSelect} />
                            </InfoPanelRow>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
